module.exports = __webpack_public_path__ + "static/media/php.61807ca4.png";